import { ItemRender as ItemRenderType } from "antd/lib/upload/interface";
import { UploadResponseFile } from "../../model/types";
import { FileListItem } from "@/shared/form/upload/ui/attachment/file-list-item";

/* eslint-disable react/display-name */
export const itemRenderer =
  ({ disabled }: { disabled?: boolean }): ItemRenderType<UploadResponseFile> =>
  (_, file, __, actions) => {
    return <FileListItem file={file} actions={actions} disabled={disabled} />;
  };
